<script>
import { Doughnut, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

const clickHandler = (that) => {
  return (e, legendItem) => {
    that.$emit('legendclick', legendItem)
  }
}

export default {
  extends: Doughnut,
  mixins: [reactiveProp],
  // props: ['options'],
  data() {
    return {
      options: {
        cutoutPercentage: 60,
        legend: {
          position: 'right',
          align: 'left',
          padding: {
            left: 0,
          },
          labels: {
            usePointStyle: true,
          },
          onClick: clickHandler(this),
          fullWidth: true,
          weight: 1000000,
        },
        responsive: true,
        maintainAspectRatio: false,
        aspectRatio: 20,
      },
    }
  },
  mounted() {
    // this.chartData is created in the mixin.
    // If you want to pass options please create a local options object
    this.renderChart(this.chartData, this.options)
  },
  watch: {
    chartData() {
      this.$data._chart.update()
    },
  },
}
</script>

<style></style>
